<section class="lpf-section">
	<div class="container">
		<div class="lpf-layout">
			<!-- Testimonials -->
			<div class="lpf-testimonials">
				<div class="lpf-head">
					<p class="lpf-eyebrow lpf-eyebrow--orange">The Wall of Love</p>
					<h2 class="lpf-title">What Our Guests Are Saying</h2>
				</div>

				<div class="lpf-testimonials-body">
					<div class="lpf-rating" aria-label="Average rating 5.0 out of 5 based on 1411 reviews">
						<div class="lpf-rating-score">
							<span class="lpf-rating-value">4.6</span>
							<span class="lpf-rating-max">/5</span>
						</div>
						<div class="lpf-rating-stars" aria-hidden="true">
							@for (star of [1,2,3,4,5]; track star) {
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none">
								<path
									d="M12 2.5l2.6 5.9 6.4.7-4.8 4.3 1.4 6.3L12 16.8 6.4 19.7l1.4-6.3L3 9.1l6.4-.7L12 2.5z"
									fill="#E85325" />
							</svg>
							}
						</div>
						<p class="lpf-rating-count">Based on 1,411 Reviews</p>
					</div>

					<div class="lpf-slider-wrap" (mouseenter)="pauseSwiper()" (mouseleave)="resumeSwiper()">
						@if (isBrowser) {
						<button type="button" class="lpf-nav lpf-nav--prev" (click)="slidePrev()"
							aria-label="Previous testimonial">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M16.1659 8.89089H6.32912L10.8474 4.37259L9.69967 3.23291L3.2334 9.69918L9.69967 16.1654L10.8393 15.0258L6.32912 10.5075H16.1659V8.89089Z"
									fill="black" />
							</svg>
						</button>
						<button type="button" class="lpf-nav lpf-nav--next" (click)="slideNext()"
							aria-label="Next testimonial">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M3.23287 8.89138H13.0697L8.55137 4.37308L9.69914 3.2334L16.1654 9.69967L9.69914 16.1659L8.55946 15.0263L13.0697 10.5079H3.23287V8.89138Z"
									fill="white" />
							</svg>
						</button>

						<!-- Swiper web components break Angular hydration (hasAttribute / type null). Browser-only + skip hydration. -->
						<swiper-container #testimonialSwiper ngSkipHydration loop="true" autoplay="true"
							autoplay-delay="3500" autoplay-disable-on-interaction="false" slides-per-view="1"
							space-between="0" class="custom-swiper lpf-swiper">
							@for (record of sectionData; track record.id) {
							<swiper-slide>
								<article class="lpf-card">
									<div class="lpf-card-top">
										<div class="lpf-user">
											<div class="lpf-avatar">
												@if (record?.image_url) {
												<img [src]="record.image_url + '?width=96'"
													[alt]="getReviewerName(record)" width="48" height="48"
													loading="lazy" />
												} @else {
												<span class="lpf-avatar-fallback" aria-hidden="true">{{
													getReviewerName(record).charAt(0) }}</span>
												}
											</div>
											<div class="lpf-user-meta">
												<h3 class="lpf-user-name">{{ getReviewerName(record) }}</h3>
												<p class="lpf-user-time">{{ getTimeAgo(record?.updated_at ||
													record?.created_at) }}</p>
											</div>
										</div>
									</div>
									<div class="lpf-card-body">
										<p class="lpf-quote">{{ getReviewText(record) }}</p>
									</div>
									<span class="lpf-quote-mark" aria-hidden="true">”</span>
								</article>
							</swiper-slide>
							}
						</swiper-container>
						} @else if (sectionData?.length) {
						<!-- SSR / no-JS: first review card so content still paints without Swiper -->
						<article class="lpf-card">
							<div class="lpf-card-top">
								<div class="lpf-user">
									<div class="lpf-avatar">
										@if (sectionData[0]?.image_url) {
										<img [src]="sectionData[0].image_url + '?width=96'"
											[alt]="getReviewerName(sectionData[0])" width="48" height="48"
											loading="lazy" />
										} @else {
										<span class="lpf-avatar-fallback" aria-hidden="true">{{
											getReviewerName(sectionData[0]).charAt(0) }}</span>
										}
									</div>
									<div class="lpf-user-meta">
										<h3 class="lpf-user-name">{{ getReviewerName(sectionData[0]) }}</h3>
										<p class="lpf-user-time">{{ getTimeAgo(sectionData[0]?.updated_at ||
											sectionData[0]?.created_at) }}</p>
									</div>
								</div>
							</div>
							<div class="lpf-card-body">
								<p class="lpf-quote">{{ getReviewText(sectionData[0]) }}</p>
							</div>
							<span class="lpf-quote-mark" aria-hidden="true">”</span>
						</article>
						}
					</div>
				</div>
			</div>

			<div class="lpf-divider" aria-hidden="true"></div>

			<!-- Brand Partners -->
			<div class="lpf-partners">
				<div class="lpf-head">
					<p class="lpf-eyebrow lpf-eyebrow--blue">Trusted By</p>
					<h2 class="lpf-title">Brand Partners</h2>
				</div>

				<div class="lpf-partners-grid">
					@for (partner of partnersList; track partner.id) {
					<div class="lpf-partner-card">
						@if (partner?.image_url) {
						<img class="lpf-partner-logo" [src]="partner.image_url + '?width=200'"
							[alt]="partner?.name || 'Brand partner'" loading="lazy" width="140" height="56" />
						}
					</div>
					}
				</div>
			</div>
		</div>
	</div>
</section>
